import React from "react";

export default function CompanyRegisterForm({
  data,
  onChange,
  onSubmit,
  error = null,
  loading = false,
  formId = "company-register-form",
  hideSubmitButton = false,
  submitLabel = "Create Account",
}) {
  const handleChange = (event) => {
    const { name, value } = event.target;
    if (onChange) onChange(name, value);
  };

  return (
    <form id={formId} onSubmit={onSubmit} className="auth-form">
      {error && <div className="auth-alert">{error}</div>}
      <div className="auth-field">
        <label>Company Name</label>
        <input
          className="auth-input"
          name="companyName"
          value={data?.companyName || ""}
          onChange={handleChange}
          placeholder="Company Name"
          required
        />
      </div>
      <div className="auth-form-grid">
        <div className="auth-field">
          <label>Your First Name</label>
          <input
            className="auth-input"
            name="adminFirstName"
            value={data?.adminFirstName || ""}
            onChange={handleChange}
            placeholder="John"
            required
          />
        </div>
        <div className="auth-field">
          <label>Your Last Name</label>
          <input
            className="auth-input"
            name="adminLastName"
            value={data?.adminLastName || ""}
            onChange={handleChange}
            placeholder="Doe"
            required
          />
        </div>
      </div>
      <div className="auth-field">
        <label>Work Email</label>
        <input
          className="auth-input"
          type="email"
          name="adminEmail"
          value={data?.adminEmail || ""}
          onChange={handleChange}
          placeholder="admin@company.com"
          required
        />
      </div>
      <div className="auth-field">
        <label>Password</label>
        <input
          className="auth-input"
          type="password"
          name="adminPassword"
          value={data?.adminPassword || ""}
          onChange={handleChange}
          placeholder="Create a password"
          required
        />
      </div>
      <div className="auth-field">
        <label>Confirm Password</label>
        <input
          className="auth-input"
          type="password"
          name="confirmPassword"
          value={data?.confirmPassword || ""}
          onChange={handleChange}
          placeholder="Confirm your password"
          required
        />
      </div>

      {!hideSubmitButton && (
        <button
          type="submit"
          className="auth-btn auth-btn-primary"
          disabled={loading}
        >
          {loading ? "Creating..." : submitLabel}
        </button>
      )}
    </form>
  );
}

